export default __webpack_public_path__ + "static/media/zero.a170f75d.webp";